/* do some code for customising cloudsearch */

//we need an open/close button
function build_cloudsearch_button(){
  target = document.querySelector('.collection-products');
  var button_div = document.createElement('div');
  button_div.className = 'cloudsearch-custom-button';
  const button_html = "Filter & Sort by +";
  button_div.textContent = button_html;
  
  target.appendChild(button_div);

  //this triggers the app button
  button_div.onclick = function(){ document.querySelector('.cloud-search-page-controls__filters-link').click() }
}


document.addEventListener('DOMContentLoaded', function() {
    //wait a bit, as it takes a while for the cloud search to load
    setTimeout(function(){ build_cloudsearch_button(); } ,100);
}, false);
